// All MUI component overrides and legacy component settings.
// Receives `palette` from createPalette() so colors stay synchronized.

import type { Components, Palette } from '@mui/material/styles';

// ---- Component factory ----

export default function createComponents(palette: Palette): Components {
  return {
    // ---- MUI standard overrides ----

    MuiModal: {
      defaultProps: {
        // Allows typing into Intercom while a dialog is open.
        // Side effect: may reduce focus-trap accessibility enforcement.
        disableEnforceFocus: true,
      },
    },
    MuiInputBase: {
      defaultProps: {
        inputProps: {
          autoCorrect: 'off',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        legend: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        input: {
          letterSpacing: '0.01071em',
        },
        underline: {
          '&:after': {
            borderBottomColor: palette.secondary.light,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          '&$shrink': {
            backgroundColor: palette.background.paper,
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: { padding: 24 },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: { padding: 24 },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        spacing: { padding: 24 },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: palette.secondary.light,
          },
        },
      },
    },

  };
}
